import React, { ChangeEvent, useEffect, useState } from "react";

import { NotificationTemplateModel } from "@admin/domain/notifications/models/NotificationModel";
import { saveNotification } from "@admin/domain/notifications/api";
import Editor from "@admin/components/Editor";
import Input from "@admin/components/Input";
import TextArea from "@admin/components/TextArea";
import DateTimeInput from "@admin/components/DateTimeInput";
import PushRedirectSettings from "@admin/pages/NotificationEditor/PushRedirectSettings";
import Select from "@admin/components/Select";

const LIST_URL = `/admin/notifications` as const;

export default function NotificationEditor() {
    const notification = window.CMS.notification || null;
    const notificationTemplates = window.CMS.notificationTemplates || null;

    const execute = async (body: FormData) => {
        await saveNotification(notification, body);
    };

    const [options, setOptions] = useState<Record<string, string>>({});
    const [title, setTitle] = useState<string | undefined>(notification?.title || ``);
    const [text, setText] = useState<string | undefined>(notification?.text || ``);
    useEffect(() => {
        const options = {
            "": ``,
        };
        (notificationTemplates || []).forEach(({ id, title }) => {
            options[id] = title;
        });
        setOptions(options);
    }, []);
    const selectNotificationTemplate = (event: ChangeEvent<HTMLSelectElement>) => {
        if (notificationTemplates && notificationTemplates.length > 0) {
            const notificationTemplate =
                notificationTemplates?.find(
                    (template: NotificationTemplateModel) => template.id == event.target.value,
                ) || null;
            setTitle(notificationTemplate?.title);
            setText(notificationTemplate?.text);
        }
    };

    return (
        <Editor backUrl={`${LIST_URL}/${notification?.id || ``}`} onSubmit={execute}>
            {options && (
                <Select
                    label="Заполнить заголовок и текст из шаблона"
                    options={options}
                    name={`notification_template_id`}
                    onChange={selectNotificationTemplate}
                />
            )}
            <Input label="Заголовок" name="title" defaultValue={title} disabled={notification?.is_sent} />

            <TextArea
                label="Текст"
                name="text"
                defaultValue={text || ``}
                disabled={notification?.is_sent}
                required={!notification?.is_sent}
            />

            <p>
                Каналы события «Рассылка из CMS» выбираются в <a href="/admin/settings">общих настройках</a>.
            </p>
            <input type="hidden" name="channels[]" value="web" />
            <input type="hidden" name="channels[]" value="push" />
            <PushRedirectSettings
                redirectType={notification?.parameters?.redirect_type || null}
                redirectEntityTitle={notification?.parameters?.redirect_entity_title || null}
                redirectEntityValue={notification?.parameters?.redirect_entity_value || null}
            />

            <DateTimeInput
                label="Дата и время отправки"
                name="send_at"
                defaultValue={notification?.send_at}
                disabled={notification?.is_sent}
            />
        </Editor>
    );
}
